import * as React from 'react';
import { ReactNode, RefObject, useRef } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { WorkPersonOtherDTO } from 'api/core';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { ValidationResults } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { SelectItem } from 'primereact/selectitem';

interface Props {
  person: WorkPersonOtherDTO;
  validation: ValidationResults;
  checkPermission: CheckPermissionFunction;
  onChange: (person: WorkPersonOtherDTO) => void;
  autoFocus: boolean;
  roleOptions: SelectItem[];
}

export const LinkedPersonExtern = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const inputRef: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  if(props.autoFocus && inputRef.current) {
    inputRef.current.focus();
  }

  return <>
    <LabelledInputText
      autoFocus={props.autoFocus}
      ref={inputRef}
      className={'w-full'}
      wrapperClassName={'flex-1 min-w-0'}
      value={props.person.surname}
      id={`workPerson-${props.person.sequence}-surname`}
      permissions={props.checkPermission('surname')}
      validation={props.validation.fields?.surname}
      onChange={(surname: string): void => props.onChange({...props.person, surname})}
      label={'work.attr.person.attr.surname'}
    />
    <LabelledInputText
      className={'w-full'}
      wrapperClassName={'flex-1 min-w-0'}
      value={props.person.givenname}
      id={`workPerson-${props.person.sequence}-givenname`}
      permissions={props.checkPermission('givenname')}
      validation={props.validation.fields?.givenname}
      onChange={(givenname: string): void => props.onChange({...props.person, givenname})}
      label={'work.attr.person.attr.givenName'}
    />
    <LabelledDropdown
      className={'w-full border-noround-top'}
      wrapperClassName={'flex-1 min-w-0'}
      value={props.person.role}
      id={`workPerson-${props.person.sequence}-role`}
      permissions={props.checkPermission('role')}
      validation={props.validation.fields?.role}
      onChange={(role: string): void => props.onChange({...props.person, role})}
      label={'work.attr.person.attr.role'}
      options={props.roleOptions}/>
  </>;
};
